/**
 * filter for grouping marketing groups into counts
 */
angular.module('bookingApp').filter('marketingGroupCount', function(){
    return function(input){
        var counts = [];
        for(var i = 0; i < input.length; i++){
            if(!input[i].roomDetails.marketingGroup){
                if(counts['rooms'] === undefined){
                    counts['rooms'] = 0;
                }
                counts['rooms'] += 1;
                input[i].marketingGroupCount = counts['rooms'];
            } else {
                if(counts[input[i].roomDetails.marketingGroup.iBexName] === undefined){
                    counts[input[i].roomDetails.marketingGroup.iBexName] = 0;
                }
                counts[input[i].roomDetails.marketingGroup.iBexName] += 1;
                input[i].marketingGroupCount = counts[input[i].roomDetails.marketingGroup.iBexName];
            }
        }
        return input;
        // if(marketingGroupCounts[marketingGroup.iBexName] === undefined){
        //     marketingGroupCounts[marketingGroup.iBexName] = 1;
        //     return 1;
        // }
        // marketingGroupCounts[marketingGroup.iBexName] += 1;
        // return marketingGroupCounts[marketingGroup.iBexName];
    };
});